import Model from './Model'
export default class Contracts extends Model {

    resource()
    {
        return 'contracts'
    }

    get drivingLicenseStatuses() {
        return [{
            value: 'NONE',
            text: 'Fara permis de conducere'
        }, {
            value: 'REVOKED_LICENSE',
            text: 'Permis de conducere anulat'
        }, {
            value: 'AVAILABLE_LICENSE',
            text: 'Permis de conducere'
        }]
    }

    get contractScopes() {
        return [
            'AM',
            'A1',
            'A1x',
            'A2',
            'A',
            'B1',
            'B',
            'B ATM - COD 78',
            'B extins - COD 96',
            'C1',
            'C',
            'D1',
            'D',
            'BE',
            'C1E',
            'CE',
            'D1E',
            'DE',
            'TR',
            'TV',
            'TB',
        ]
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download`
    }
}
